import * as api from '../../constants';
import { actions as IMActions } from '../../components/IMPlatform';
import apis from '../../utils/DoRequest';
import * as apiConstants from '../../constants';
import * as apiIm from '../../components/IMPlatform/api/api';

//https://im.wusong.com
export const getIm = (lawyerId, userId, getInfo, token) => {
    return async dispatch => {
        if (getInfo) {
            const infoData = await apis.doGETRequest(apiConstants.IM_LAWYER_INFO + `?lawyerId=${lawyerId}`);
            dispatch(receiveIm(infoData.data));
        } else {
            const accountData = await apiIm.getRequest(
                `${apiIm.BASE}/cquser/toUserAccount?userId=${userId ? userId : ''}&pId=${lawyerId}`
            );
            const infoData = await apis.doGETRequest(
                apiConstants.IM_LAWYER_INFO + `?lawyerId=${lawyerId}`,
                token
            );
            dispatch(IMActions.createSession(accountData.data));
            dispatch(receiveIm(infoData.data));
        }
    };
};
export const receiveIm = imlaywerInfo => ({ type: api.GET_IM_MESSAGE, imlaywerInfo });

export const getNumNotice = num => {
    return async dispatch => {
        dispatch(receiveNum(num));
    };
};
export const receiveNum = numNotice => ({ type: api.GET_NUM_NOTICE, numNotice });
